import moment from "moment";

// Filtre, hladanie a cislo strany zit v adrese, nie iba v stave komponentu.
//
// Predtym platilo: nastavis filtre, otvoris zaznam, das krok spat a si zase
// na prvej strane bez filtrov. Ked su hodnoty v adrese, prehliadac ich pri
// kroku spat vrati sam, a da sa poslat kolegovi odkaz na presne ten vypis.
//
// Popis je mapa kluc -> typ: "text" | "cislo" | "ano/nie" | "obdobie" | "rozsah".

const naText = (hodnota, typ) => {
  if (hodnota === undefined || hodnota === null || hodnota === "") return null;
  if (typ === "ano/nie") return hodnota ? "1" : "0";
  if (typ === "obdobie") {
    const od = hodnota[0] ? hodnota[0].format("YYYY-MM-DD") : "";
    const do_ = hodnota[1] ? hodnota[1].format("YYYY-MM-DD") : "";
    return od || do_ ? `${od}_${do_}` : null;
  }
  // Rozsah cisel, napriklad suma od a do. Prazdna strana ostava prazdna.
  if (typ === "rozsah") {
    const od = hodnota[0] === undefined || hodnota[0] === null ? "" : String(hodnota[0]);
    const do_ = hodnota[1] === undefined || hodnota[1] === null ? "" : String(hodnota[1]);
    return od.trim() || do_.trim() ? `${od}_${do_}` : null;
  }
  return String(hodnota);
};

const zTextu = (text, typ) => {
  if (text === undefined || text === null || text === "") return undefined;
  if (typ === "ano/nie") return text === "1";
  if (typ === "cislo") {
    const c = Number(text);
    return Number.isFinite(c) ? c : undefined;
  }
  if (typ === "rozsah") {
    const [od, do_] = String(text).split("_");
    return od || do_ ? [od || "", do_ || ""] : undefined;
  }
  if (typ === "obdobie") {
    const [od, do_] = String(text).split("_");
    const rozsah = [
      od ? moment(od, "YYYY-MM-DD") : null,
      do_ ? moment(do_, "YYYY-MM-DD") : null,
    ];
    return rozsah[0] || rozsah[1] ? rozsah : undefined;
  }
  return text;
};

/** Z adresy vytiahne hodnoty podla popisu. */
export const zUrl = (search, popis) => {
  const parametre = new URLSearchParams(search || "");
  const vysledok = {};
  Object.entries(popis).forEach(([kluc, typ]) => {
    const hodnota = zTextu(parametre.get(kluc), typ);
    if (hodnota !== undefined) {
      vysledok[kluc] = hodnota;
    }
  });
  return vysledok;
};

/** Z hodnot poskladá retazec do adresy. Prazdne hodnoty vynecha. */
export const doUrl = (hodnoty, popis) => {
  const parametre = new URLSearchParams();
  Object.entries(popis).forEach(([kluc, typ]) => {
    const text = naText(hodnoty[kluc], typ);
    if (text !== null) {
      parametre.set(kluc, text);
    }
  });
  const retazec = parametre.toString();
  return retazec ? `?${retazec}` : "";
};
